import { W as WuiCloseButton$1, d as defineCustomElement$1 } from './close-button.js';

const WuiCloseButton = WuiCloseButton$1;
const defineCustomElement = defineCustomElement$1;

export { WuiCloseButton, defineCustomElement };

//# sourceMappingURL=wui-close-button.js.map